<template>
  <div v-if="value" class="home-info-container">
    <div class="home-info-header px-3">
      <h5 class="title my-0">
        บ้านเลขที่
        <span>{{ value.addressNo }}</span>
        (Home ID: <span>{{ homeId }}</span
        >) (Plot: <span>{{ plotCode }}</span
        >)
      </h5>
      <div>
        <span>{{ countOwner }} ผู้ถือกรรมสิทธิ์</span>
        <span v-if="countResident > 0">{{ countResident }} ผู้อยู่อาศัย</span>
        <span v-if="countRenter > 0">{{ countRenter }} ผู้เช่า</span>
      </div>
    </div>
    <div class="members">
      <div class="member-group">
        <h2 class="title px-3">ผู้ถือกรรมสิทธิ์ {{ countOwner }} คน</h2>
        <people
          v-for="(people, index) in owners"
          :key="index"
          :people="people"
          :show-greeting="true"
          role="owner"
          @new-message="onNewMessage"
        />
      </div>
      <div v-show="countResident > 0" class="member-group">
        <h2 class="title px-3">ผู้อยู่อาศัย {{ countResident }} คน</h2>
        <people
          v-for="(people, index) in residents"
          :key="index"
          :people="people"
          role="resident"
          @new-message="onNewMessage"
        />
      </div>
      <div v-show="countRenter > 0" class="member-group">
        <h2 class="title px-3">ผู้เช่า {{ countRenter }} คน</h2>
        <people
          v-for="(people, index) in renters"
          :key="index"
          :people="people"
          role="renter"
          @new-message="onNewMessage"
        />
      </div>
    </div>
    <div class="">
      <reply-box
        v-if="showReplyBox && selectedContactId"
        :contact-id="selectedContactId"
        :project-id="projectId"
        :home-id="homeId"
        :title="replyBoxTitle"
        :place-holder="'พิมพ์ข้อความที่นี่'"
        type="greeting"
        @message-close="onMessageBoxClose"
        @message-send-success="onMessageSendSuccess"
        @message-send-fail="onMessageSendFail"
      ></reply-box>
    </div>
  </div>
</template>

<script>
import ReplyBox from "@/components/admin/view/contact/ReplyBox"
import People from "./People"

export default {
  components: {
    People,
    ReplyBox,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      projectId: null,
      showReplyBox: false,
      selectedContactId: null,
      replyBoxTitle: null,
    }
  },
  computed: {
    countOwner() {
      return this.value.owners.length || 0
    },
    countResident() {
      return this.value.residents.length || 0
    },
    countRenter() {
      return this.value.renters.length || 0
    },
    owners() {
      return this.value.owners
    },
    renters() {
      return this.value.renters
    },
    residents() {
      return this.value.residents
    },
    homeId() {
      return this.value.homeId
    },
    plotCode() {
      return this.value.plotCode
    },
  },
  methods: {
    onNewMessage(people) {
      this.projectId = this.value.projectId
      this.selectedContactId = people.userId
      this.showReplyBox = true
      this.replyBoxTitle = people.fullname
    },
    onMessageSendSuccess({ topicId }) {
      this.$router.push({ name: "Contact", params: { contactId: topicId } })
    },
    onMessageSendFail() {},
    onMessageBoxClose() {
      this.projectId = null
      this.selectedContactId = null
      this.showReplyBox = false
      this.replyBoxTitle = null
    },
  },
}
</script>

<style lang="scss" scoped>
.home-info-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.home-info-header {
  border-bottom: 1px solid#e0e0e0;
  padding: 10px 0;
  h5 {
    font-size: 16px;
    font-weight: bold;
    span {
      font-size: 16px;
      font-weight: bold;
    }
  }
  span {
    color: #4a4a4a;
    font-size: 11px;
  }
}
.members {
  flex: 1;
  overflow: auto;
}
.member-group {
  .title {
    margin: 0;
    padding: 9px 0;
    font-size: 16px;
    font-weight: bold;
    background-color: #f9f9f9;
  }
}
</style>
